export const truncateString = (string, maxCharLength) => {
    if (string.length <= maxCharLength) {
        return string;
    }
    const ellipses = '...';
    const base = string.substring(0, maxCharLength - ellipses.length);

    return base.trim() + ellipses;
};
